import { ArrowRight } from "lucide-react";
import { Chapter, Reveal } from "./shared";
import { WHATSAPP_URL } from "@/lib/api";
import { useSiteConfig, fullUrl } from "@/context/SiteConfigContext";

const SERVICES = [
  { key: "fogao", img: "/assets/serv-fogao.jpg", title: "Conversão de Fogão", desc: "Converta seu fogão para gás natural e tenha mais segurança, economia e praticidade no dia a dia, sem sujeira ou dor de cabeça." },
  { key: "aquecedor", img: "/assets/serv-aquecedor.jpg", title: "Instalação de Aquecedor", desc: "Evite riscos e garanta água quente sempre com manutenção preventiva. Mantenha seu aquecedor seguro e eficiente." },
  { key: "estanqueidade", img: "/assets/serv-estanqueidade.jpg", title: "Teste de Estanqueidade", desc: "Teste completo para garantir que não há vazamentos na instalação." },
  { key: "tubulacao", img: "/assets/serv-tubulacao.jpg", title: "Tubulação de Gás", desc: "Instalação, reparo e manutenção com materiais homologados. Resolvemos vazamentos de gás com urgência." },
  { key: "laudos", img: "/assets/serv-laudos.jpg", title: "Laudos Técnicos", desc: "Emissão de laudos técnicos conforme NBR 15526 para sua segurança." },
  { key: "manutencao", img: "/assets/serv-manutencao.jpg", title: "Manutenção Preventiva", desc: "Não corra riscos! Evite vazamentos e imprevistos com revisão técnica regular, realizada por profissionais experientes." },
];

export const Services = () => {
  const cfg = useSiteConfig();
  const customImages = cfg.service_images || {};
  const customServices = cfg.services || [];

  return (
  <section id="servicos" className="bg-zinc-50 py-24 sm:py-32" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Chapter num="04 — Especialidades" title="Nossos" accent="Serviços" />
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const custom = customServices.find((x) => x.key === s.key) || {};
          return (
          <Reveal key={s.title} delay={(i % 3) * 0.1}>
            <div
              data-testid={`service-card-${i}`}
              className="group h-full overflow-hidden rounded-2xl border border-zinc-200 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-[0_24px_50px_-20px_rgba(0,0,0,0.25)]"
            >
              <div className="overflow-hidden bg-zinc-100">
                <img
                  src={fullUrl(customImages[s.key]) || s.img}
                  alt={s.title}
                  loading="lazy"
                  className="h-auto w-full object-contain transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl font-bold uppercase text-zinc-900">{custom.title || s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-500">{custom.desc || s.desc}</p>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`service-cta-${i}`}
                  className="mt-4 inline-flex items-center gap-1.5 font-display text-sm font-bold uppercase tracking-wider text-[#E8A200] transition-colors hover:text-[var(--primary)]"
                >
                  Saiba mais
                  <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </div>
            </div>
          </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};
